module.exports = __webpack_public_path__ + "static/plastic-school-bus-pass-photo-id-465acb5f5e58770c4df3f90d8e75ae09.jpg";